/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdButtonProps } from './type';

export const buttonDefaultProps: TdButtonProps = {
  block: false,
  disabled: false,
  ghost: false,
  loading: false,
  shape: 'rectangle',
  size: 'medium',
  type: 'button',
  variant: 'base',
};
